<template>
    <div class="form-container" @keyup.enter="onClickSave">
        <Header
            :showRightButton="!$v.$invalid"
            :rightButtonText="$t('form.button.save')"
            @clickRightButton="onClickSave"
        >
            <template slot="center">
                <Title
                    :model.sync="$v.form.dashboard.title.$model"
                    :state="fieldIsValid($v.form.dashboard.title)"
                    :validations="{
                        required: $v.form.dashboard.title.required,
                        maxLength: $v.form.dashboard.title.maxLength,
                    }"
                />
            </template>
        </Header>
        <section class="body">
            <ChartsOptions
                class="reports-options"
                :selectedOptions.sync="$v.form.charts.$model"
            />
            <Charts
                v-if="hasSomeChart"
                class="charts"
                :showFilters="false"
                :showSubjectsResults="showSubjectsResults"
                :showEvaluationsStatus="showEvaluationsStatus"
                :showQuestionnaireResults="showQuestionnaireResults"
                :showEvaluationsStatusBySections="
                    showEvaluationsStatusBySections
                "
            />
            <div v-if="!hasSomeChart" class="without-charts">
                {{ $t('reports.dashboards.withoutCharts') }}
            </div>
        </section>
    </div>
</template>
<script>
import Header from '../Header'
import Charts from '../charts/Charts'
import { validationMixin } from 'vuelidate'
import { Title, ChartsOptions } from './components'
import { required, maxLength } from 'vuelidate/lib/validators'
import { CHART_INFO_TYPES } from '@/views/reports/constants'
export default {
    components: {
        Title,
        Charts,
        Header,
        ChartsOptions,
    },
    mixins: [validationMixin],
    props: {
        formData: Object,
    },
    validations: {
        form: {
            dashboard: {
                title: {
                    required,
                    maxLength: maxLength(70),
                },
            },
            charts: {
                required,
                $each: {
                    format: required,
                    infoType: required,
                },
            },
        },
    },
    data() {
        return {
            form: {
                dashboard: {
                    title: '',
                },
                charts: [],
            },
        }
    },
    computed: {
        showSubjectsResults() {
            return this.hasChart(CHART_INFO_TYPES.SUBJECTS_RESULTS_BY_NETWORK)
        },
        showEvaluationsStatus() {
            return this.hasChart(CHART_INFO_TYPES.EVALUATIONS_STATUS)
        },
        showQuestionnaireResults() {
            return this.hasChart(CHART_INFO_TYPES.QUESTIONNAIRES_RESULTS)
        },
        showEvaluationsStatusBySections() {
            return this.hasChart(CHART_INFO_TYPES.EVALUATIONS_STATUS_BY_TEAM)
        },
        hasSomeChart() {
            return this.charts.length > 0
        },
        charts() {
            return this.form.charts.map(c => c.infoType)
        },
    },
    mounted() {
        this.setFormFields()
    },
    watch: {
        '$v.$anyDirty': function() {
            this.$emit('isChanged')
        },
    },
    methods: {
        hasChart(chartType) {
            return this.charts.includes(chartType)
        },
        setFormFields() {
            if (!this.formData) {
                return
            }

            this.form = { ...this.formData }
        },
        fieldIsValid(field) {
            return field.$dirty ? !field.$invalid : null
        },
        onClickSave() {
            if (!this.formIsValid()) {
                return
            }

            const parsedForm = this.parseForm()
            this.$emit('submit', parsedForm)
        },
        formIsValid() {
            this.$v.$touch()
            return !this.$v.$invalid
        },
        parseForm() {
            return {
                ...this.form,
                charts: this.form.charts.map(c => {
                    return {
                        format: c.format,
                        info_type: c.infoType,
                    }
                }),
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.form-container {
    color: #6e6e6e;

    .header {
        max-height: 100px;
    }

    .body {
        display: flex;
        padding: 23px 21px;
        margin: 0 23px 37px 23px;
        background-color: white;
        border: 1px solid #bec0c0;
        border-radius: 3px;

        .reports-options {
            min-width: 283px;
            margin-right: 30px;
        }

        .charts {
            width: 100%;
        }

        .without-charts {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 150px;
            width: 100%;
            font-size: 18px;
        }
    }
}
</style>
